import { defineMessages } from "react-intl";

export const lineAlertMessages = defineMessages({
  notPublished: {
    id: "QL4a0Z",
    defaultMessage: "Not published in this channel",
    description: "alert message",
  },
  notAvailable: {
    id: "dDCLFW",
    defaultMessage: "Not available for sale this channel",
    description: "alert message",
  },
  notExists: {
    id: "ZJOX8n",
    defaultMessage: "Product no longer exists",
    description: "alert message",
  },
});
